import { BionicNavigation, userHasValidRolesForNavItem } from '@/assets/js/constants/navigation'
import { defineNuxtRouteMiddleware, useNuxtApp, createError, showError } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()

  const user = nuxtApp.$store.getters.user
  // User roles should exist provided the user exists/is set. If they do not exist then
  // they are expected to not be logged in. If they are not logged in and visit a page that
  // requires auth, they will be redirected to the /login/ page. However, since we are redirecting
  // them by setting window.location we might end up hitting this middleware before they get to
  // the login page. This is an early return to prevent unauthorized users from seeing a 404 page
  // flash before ultimately seeing the login page.
  if (!user?.roles) {
    return
  }

  for (const navNode of BionicNavigation) {
    const isPage = to.path.includes(navNode.link) || to.fullPath.includes(navNode.link)
    if (isPage && !userHasValidRolesForNavItem(navNode, user)) {
      throw createError({ statusCode: 404, message: 'This page does not exist', fatal: true })
    }
  }
})
